import { Form, Input, Radio } from "antd";

const RadioTextBoxField = ({ field, radioStates, onRadioChange }) => (
  <div key={field.name}>
    <Form.Item
      hidden={field?.hidden}
      name={`${field.name}_toggle`}
      label={field.label}
      rules={field.rules}
    >
      <Radio.Group
        onChange={(e) => onRadioChange(field.name, e)}
        defaultValue="disable"
      >
        <Radio value="enable">Input</Radio>
        <Radio value="disable">None</Radio>
      </Radio.Group>
    </Form.Item>

    <Form.Item
      name={field.name}
      extra={field.extra}
      rules={field.rules}
      style={{ marginBottom: 24 }}
    >
      <Input
        placeholder={field.placeholder}
        disabled={radioStates[field.name] ?? true}
      />
    </Form.Item>
  </div>
);

export default RadioTextBoxField;
